import { Navigate, Outlet } from 'react-router-dom';
import { useStateValue } from '../context';

const PublicRoutes = ({ restricted = false }) => {
  const [{ access }] = useStateValue();
  return access && restricted ? <Navigate to="/account" /> : <Outlet />;
};

export default PublicRoutes;
